import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Login from './Login';
import Register from './Register';

const AuthModal = ({ isOpen, onClose, initialMode = 'login' }) => {
  const [mode, setMode] = useState(initialMode);

  // 每次打开时同步入口模式（登录/注册按钮）
  useEffect(() => {
    if (isOpen) {
      setMode(initialMode);
    }
  }, [isOpen, initialMode]);

  if (!isOpen) return null;

  const handleSwitchToLogin = () => {
    setMode('login');
  };

  const handleSwitchToRegister = () => {
    setMode('register');
  };

  const handleClose = () => {
    setMode('login'); // 重置为登录模式
    onClose();
  };

  // 通过 portal 渲染到 body：Sidebar 的 aside 带有 transform，
  // 会把 fixed 定位的弹窗限制在侧边栏宽度内并被 overflow 裁剪
  return createPortal(
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* 背景遮罩 */}
      <div
        className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm transition-all duration-300"
        onClick={handleClose}
      ></div>

      {/* 模态框内容：移动端贴底全宽弹出，桌面端居中 */}
      <div className="flex min-h-full items-end sm:items-start justify-center sm:pt-24 sm:pb-8 sm:px-4">
        <div className="relative w-full max-w-lg transform transition-all duration-300 scale-100">
          {/* 装饰性背景（仅桌面端显示，移动端保持简洁） */}
          <div className="hidden sm:block absolute inset-0 bg-gradient-to-br from-sage-50 to-emerald-50 rounded-2xl transform rotate-1 scale-105 opacity-30"></div>
          <div className="hidden sm:block absolute inset-0 bg-gradient-to-tl from-teal-50 to-sage-50 rounded-2xl transform -rotate-1 scale-105 opacity-30"></div>

          {/* 主要内容区域 */}
          <div className="relative bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl border border-sage-100 overflow-hidden">
            {/* 顶部装饰条 */}
            <div className="h-2 bg-gradient-to-r from-sage-400 via-emerald-400 to-teal-400"></div>

            {/* 关闭按钮（放在卡片内部，移动端不会贴到屏幕边缘） */}
            <button
              onClick={handleClose}
              aria-label="关闭"
              className="absolute top-4 right-4 z-20 bg-sage-50 rounded-full p-2.5 shadow-md hover:bg-sage-100 active:bg-sage-200 transition-all duration-200 border border-sage-200"
            >
              <svg className="w-5 h-5 text-sage-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* 认证组件 */}
            <div className="p-5 pt-6 sm:p-8">
              {mode === 'login' ? (
                <Login
                  onSwitchToRegister={handleSwitchToRegister}
                  onClose={handleClose}
                />
              ) : (
                <Register
                  onSwitchToLogin={handleSwitchToLogin}
                  onClose={handleClose}
                />
              )}
            </div>

            {/* iPhone 底部安全区 */}
            <div className="h-[env(safe-area-inset-bottom)] sm:hidden"></div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AuthModal;
